import SuffixInput from './SuffixInput';
import { POST_SIZES, BEAM_SIZES } from './constants';
import { FormRow, FormColumn, Group, AdditionalItemsDropdown, AdditionalWarning } from './styles';
import useCalculator from './useCalculator';
import InputError from '../../ComponentLibrary/input-elements/oc-input-error';
import Label from '../../ComponentLibrary/input-elements/oc-label';
import SelectDropdown from '../../ComponentLibrary/input-elements/oc-select-dropdown';

const AdditionalItemsForm = () => {
  const { calculatorValues, handleAdditionalItemsChange, additionalRequired, deckOverspan } = useCalculator();
  const { additionalItems } = calculatorValues;
  const {
    beamSize,
    beamSpanFeet,
    beamSpanInches,
    deckHeightFeet,
    deckHeightInches,
    quantityOfBeams,
    postQuantity,
    postSize,
  } = additionalItems;

  return (
    <AdditionalItemsDropdown collapsed label="Additional Items">
      <AdditionalWarning>
        If entering additional items, all fields are required. Please consult with the{' '}
        <a href="https://owenscorning.com/dms/10026715" target="_blank" rel="noreferrer">
          install guide
        </a>{' '}
        to ensure that beams and posts are adequately sized based upon the joist spans they are supporting
      </AdditionalWarning>
      <FormRow>
        <FormColumn>
          <Label
            forId="deckHeightFeet"
            required={additionalRequired}
            valid={!deckOverspan}
            text="Deck Height (ft. in.)"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
          />
          <Group>
            <SuffixInput
              touched={deckHeightFeet !== null}
              valid={!deckOverspan}
              required={additionalRequired}
              suffix="ft."
              name="deckHeightFeet"
              onChange={handleAdditionalItemsChange}
              value={deckHeightFeet}
              placeholder="0"
            />
            <SuffixInput
              touched={deckHeightInches !== null}
              valid={!deckOverspan}
              required={additionalRequired}
              suffix="in."
              name="deckHeightInches"
              onChange={handleAdditionalItemsChange}
              value={deckHeightInches}
              placeholder="0"
            />
          </Group>
          {deckOverspan && <InputError icon message={`Over-spanned post - Maximum height for post is 13'0"`} />}
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label
            required={additionalRequired}
            text="Post Size"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
          />
          <SelectDropdown
            required={additionalRequired}
            name="postSize"
            options={POST_SIZES}
            onChange={handleAdditionalItemsChange}
            value={postSize}
          />
        </FormColumn>
        <FormColumn>
          <Label
            required={additionalRequired}
            text="Post Quantity"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
            tooltip="Post quantity should be the number of beams +1."
          />
          <SuffixInput
            required={additionalRequired}
            name="postQuantity"
            onChange={handleAdditionalItemsChange}
            value={postQuantity}
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label
            required={additionalRequired}
            text="Beam Size"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
            tooltip={`
              <span>
                2 or 3 pieces of lumber fastened together to create a beam. See
                <a href="https://owenscorning.com/dms/10026715" target="_blank" rel="noreferrer">
                  install guide
                </a> for more info.
              </span>
             `}
          />
          <SelectDropdown
            required={additionalRequired}
            name="beamSize"
            options={BEAM_SIZES}
            onChange={handleAdditionalItemsChange}
            value={beamSize}
          />
        </FormColumn>
        <FormColumn>
          <Label
            required={additionalRequired}
            text="Quantity of Beams"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
          />
          <SuffixInput
            required={additionalRequired}
            name="quantityOfBeams"
            onChange={handleAdditionalItemsChange}
            value={quantityOfBeams}
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label
            required={additionalRequired}
            text="Beam Span (ft. in.)"
            helperText={additionalRequired ? 'Required' : ''}
            helperTextColor="#585858"
          />
          <Group>
            <SuffixInput
              touched={beamSpanFeet !== null}
              required={additionalRequired}
              suffix="ft."
              name="beamSpanFeet"
              onChange={handleAdditionalItemsChange}
              value={beamSpanFeet}
              placeholder="0"
            />
            <SuffixInput
              touched={beamSpanInches !== null}
              required={additionalRequired}
              suffix="in."
              name="beamSpanInches"
              onChange={handleAdditionalItemsChange}
              value={beamSpanInches}
              placeholder="0"
            />
          </Group>
        </FormColumn>
      </FormRow>
    </AdditionalItemsDropdown>
  );
};

export default AdditionalItemsForm;
